import { AuthGuard } from './../../shared/guards/authGuard/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegistroSalidaVisitanteComponent } from './registro-salida-visitante.component';

const routes: Routes = [
    { path: '', component: RegistroSalidaVisitanteComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class RegistroSalidaVisitanteRoutingModule { }
